const skeleton = {
  baseStyle: {
    // O padrão escuro do Chakra (gray.800 → gray.600) é azulado; aqui segue a escala zinc.
    _dark: {
      "--skeleton-start-color": "colors.app-muted",
      "--skeleton-end-color": "#3F3F46",
    },
  },
};

export default skeleton;
